export default {
  EGS_START: 'START',
  EGS_PROGRESS: 'LEVEL_PROGRESS',
  EGS_RESULTS: 'RESULTS',
}
